export default __webpack_public_path__ + "static/media/3985-bayc3593.df3b6d5b.pdf";